import { PERCENTAGE_TYPE } from '@/utils/constants/examConstants'

function isAttributePercentagePerType(typeAttribute) {
	return typeAttribute === PERCENTAGE_TYPE
}

export { isAttributePercentagePerType }
